<template>
    <div class="overflow-auto d-flex justify-content-center">

    <!-- <div class="mt-3">
      <h6>Default</h6>
      <b-pagination v-model="currentPage" :total-rows="rows"></b-pagination>
    </div> -->

    <div class="mt-5">
      <b-pagination v-model="currentPage" :total-rows="rows" size="lg" variant="dark"></b-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        rows: 100,
        currentPage: 1
      }
    }
  }
</script>

<style>

</style>